"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Numbers = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Numbers.scss");
const Numbers = _ref => {
  let {
    total,
    current,
    surrounding,
    onClick,
    className
  } = _ref;
  const clickHandler = number => () => onClick(number);
  const buildPageLink = number => /*#__PURE__*/_react.default.createElement("li", {
    key: number,
    className: (0, _classnames.default)('cds-Pagination-NumbersPage', {
      'cds-Pagination-NumbersPage--Active': current === number
    })
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: clickHandler(number),
    className: "cds-Link cds-Pagination-Link"
  }, number));
  let start, end;
  switch (true) {
    case current <= surrounding:
      start = Math.max(current - surrounding, 1);
      end = start + 2 * surrounding;
      break;
    case current + surrounding > total:
      end = Math.min(current + surrounding, total);
      start = end - 2 * surrounding;
      break;
    default:
      start = current - surrounding;
      end = current + surrounding;
      break;
  }
  start = Math.max(start, 1);
  end = Math.min(end, total);
  const pages = [];
  if (start > 1) {
    pages.push(buildPageLink(1));
  }
  if (start > 2) {
    pages.push( /*#__PURE__*/_react.default.createElement("li", {
      key: "left-separator",
      className: "cds-Pagination-NumbersSeparator"
    }, "..."));
  }
  for (let page = start; page <= end; page++) {
    pages.push(buildPageLink(page));
  }
  if (end < total - 1) {
    pages.push( /*#__PURE__*/_react.default.createElement("li", {
      key: "right-separator",
      className: "cds-Pagination-NumbersSeparator"
    }, "..."));
  }
  if (end < total) {
    pages.push(buildPageLink(total));
  }
  return /*#__PURE__*/_react.default.createElement("ol", {
    className: (0, _classnames.default)('cds-Pagination-Numbers', className)
  }, pages);
};
exports.Numbers = Numbers;
//# sourceMappingURL=Numbers.js.map